import { FC, useState } from 'react';
import { Col, Divider, Form, Input, InputNumber, Row } from 'antd';
import rule from '@/libs/antd/rules';
import { useForm } from '@/libs/antd/form';
import FleetModal from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { NAPBackgroundInfoPayload } from '@/libs/fleet-api/services/nap';
import { inputCurrency } from '@/libs/antd/input-number';

type FinanceData =
	NAPBackgroundInfoPayload['financingAndUnitRequirements'][number] & {
		index: number;
	};

type ModalData =
	| { type: 'new' }
	| {
			type: 'edit';
			data: FinanceData;
	  };

export const useFinanceModal = (
	onSubmit: (type: ModalData['type'], data: FinanceData) => void,
) => {
	const [modalData, setModalData] = useState<ModalData>();

	return {
		data: modalData,
		isOpen: Boolean(modalData),
		open: (data: ModalData) => setModalData(data),
		close: () => setModalData(undefined),
		onSubmit,
	};
};

const FinanceModal: FC<ReturnType<typeof useFinanceModal>> = (props) => {
	const { form, fieldName } = useForm<FinanceData>();

	return (
		<FleetModal
			open={props.isOpen}
			width={940}
			closable={false}
			buttonPosition="end"
			okText="SAVE"
			cancelText="BACK"
			onCancel={() => props.close()}
			onOk={form.submit}
			afterOpenChange={(isOpen) => {
				if (!isOpen) {
					form.resetFields();
				} else if (props.data?.type === 'edit') {
					form.setFieldsValue(props.data.data);
				}
			}}
		>
			<FleetTitle>Kebutuhan Pembiayaan Dan Penggunaan Unit</FleetTitle>

			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				onFinish={(values) => {
					props.close();
					props.onSubmit(props.data!.type, values);
				}}
			>
				<Form.Item
					name={fieldName('index')}
					noStyle
				/>
				<Row
					gutter={40}
					style={{ marginBlock: 20 }}
				>
					<Col span={12}>
						<Form.Item
							name={fieldName('numberOfUnits')}
							label="Jumlah Unit"
							rules={[rule.required()]}
						>
							<InputNumber min={0} />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							name={fieldName('unitBrandDetails')}
							label="Detail Merk Unit"
							rules={[rule.required()]}
						>
							<Input />
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Row
					gutter={40}
					style={{ marginBlock: 20 }}
				>
					<Col span={12}>
						<Form.Item
							name={fieldName('price')}
							label="Harga"
							rules={[rule.required()]}
						>
							<InputNumber {...inputCurrency} />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Lokasi Project"
							name={fieldName('projectLocation')}
							rules={[rule.required()]}
						>
							<Input />
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</FleetModal>
	);
};

export default FinanceModal;
